import React, {Fragment} from 'react';
import {Button, Layout, Menu, message, Modal, theme} from 'antd';
import {HashRouter, Redirect, withRouter} from 'react-router-dom';
import axios from '../interceptor/http';
import ContentRouter from "../route/index";
import {connect} from "react-redux";
import {ErrorBoundary, FallbackProps} from "react-error-boundary";
import {
    CarOutlined, CheckCircleOutlined, ContainerOutlined,
    FileDoneOutlined, FundOutlined,
    LineChartOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined
} from "@ant-design/icons";
import Auth from "../components/Authorized/auth";
const {Sider, Header} = Layout;
const router = new HashRouter();
function ErrorFallback({error, resetErrorBoundary}: FallbackProps) {
    return(
        <div role='alert'>
            <p>加载失败：</p>
            <pre>{error.message}</pre>
            <Button onClick={resetErrorBoundary}>再试一次</Button>
        </div>
    )
}
const slideTab = [
    {
        key: 'dataPane',
        label: '尾气检测',
        icon: <LineChartOutlined />
    },
    // {
    //     key: 'mainList',
    //     label: '接车单',
    //     icon: <CarOutlined />
    // },
    {
        key: 'inspection',
        label: '检查单',
        icon: <FileDoneOutlined />
    },
    {
        key: 'workManagerSub',
        label: '工单管理',
        icon: <ContainerOutlined />,
        children: [
            {
                key: 'workDataPane',
                label: '数据看板',
                icon: <FundOutlined />
            }
        ]
    }
    // (JSON.parse(localStorage.getItem('permissions')) || '').indexOf('channel_purchase_view') === -1 ? null : {
    //     key: 'agentPurchaseOrder',
    //     label: '采购订单'
    // },
    // (JSON.parse(localStorage.getItem('permissions')) || '').indexOf('channel_stock_view') === -1 ? null : {
    //     key: 'dealerInventorySub',
    //     label: '库存管理',
    //     children: [
    //         {
    //             key: 'agentDealerInventory',
    //             label: '门店库存'
    //         }
    //     ]
    // }
];
const mapDispatchToProps = (dispatch) => {
    return {
        saveChangeData(data) {
            const action = {//1:创建action消息
                type: 'saveSearchData',
                value: data,//把值传给store
            };
            dispatch(action);//2：把这个消息传给store处理
        },
    }
};
class BasicLayout extends React.Component {
    constructor() {
        super();
        this.state = {
            collapsed: false,
            defaultSelectKey: "",
            defaultSelectedKeys: [],
            insPermission: {},
            currentUserInfo: {},
            showModal: false,
            listP: [{remark: '尾气诊断系统免费使用'}, {remark: '智能云端分析检测'},
                {remark: '3分钟输出检测报告'},{remark: '线上尾气诊断治理技术培训'},
                {remark: '线上尾气治理门店营销培训'},{remark: '门店专属技术支持服务'},
                {remark: '新媒体账号搭建'},{remark: '新媒体拍摄/剪辑技巧培训'},
                {remark: '短视频文案样片支持'},{remark: '新媒体投流服务'}],
            list2: [
                {remark: '系统免费使用权'},  {remark: '线上尾气诊断治理技术培训'},
                {remark: '线上尾气治理门店营销培训', msg: '(邀约、接车转化、沟通报价)'},  {remark: '门店专属技术支持服务'},
                {remark: '案例分享'}
            ]
        };
    }
    componentDidMount() {
        const currentUserInfo = JSON.parse(localStorage.getItem('currentUserAllInfo') || '{}');
        const arr = (currentUserInfo.dealerModules || []).filter(obj => {return obj.moduleCode === 'app_inspection_manage'});
        const t: any = (arr && arr[0]) || {};
        this.changeDefaultSelectKeys();
        this.setState({
            insPermission: t,
            currentUserInfo: currentUserInfo
        })
    }
    componentWillReceiveProps() {
        this.changeDefaultSelectKeys()
    }
    handleError = () => {
        this.setState({ imgSrc: require('../assets/logoZT.png') });
    };
    changeDefaultSelectKeys = () => {
        const pathname = this.props.history.location.pathname;
        const rank = pathname.split('/');
        this.setState({
            defaultSelectedKeys: [`${rank[1]}`]
        });
    };
    menuClick = (e) => {
        router.history.push(`/${e.key}`);
        this.props.saveChangeData({page: 1, size: 10});
        this.setState({
            defaultSelectedKeys: [`${e.key}`]
        })
    }
    render() {
        return (
            <Layout>
                <Layout style={{minHeight: '100vh'}}>
                    <Sider
                        width={200}
                        collapsed={this.state.collapsed}
                        // className="siderCls"
                    >
                        <div style={{color: '#00E4FF', fontSize: '18px', fontWeight: 'bolder', textAlign: 'left',height: '50px', lineHeight: '50px', paddingLeft: '28px'}}>
                            {!this.state.collapsed && '功能菜单'}
                            {this.state.collapsed && <MenuUnfoldOutlined onClick={() => {
                                this.setState({collapsed: false})
                            }}/>}
                            {!this.state.collapsed && <MenuFoldOutlined style={{marginLeft: '10px'}} onClick={() => {
                                this.setState({collapsed: true})
                            }}/>}
                        </div>
                        <Menu
                            mode="inline"
                            selectedKeys={this.state.defaultSelectedKeys}
                            defaultSelectedKeys={['dataPane']}
                            defaultOpenKeys={['workManagerSub']}
                            onClick={(e) => this.menuClick(e)}
                            style={{
                                height: '100%',
                                borderRight: 0,
                            }}
                            items={slideTab}
                        />
                        {/*<div className="payBox" onClick={() => {*/}
                        {/*    this.setState({*/}
                        {/*        showModal: true*/}
                        {/*    })*/}
                        {/*}}>*/}
                        {/*    <div className="tit">会员权益</div>*/}
                        {/*    {this.state.insPermission.plan === 'plan_a' &&*/}
                        {/*        <div className="subTit">距产品采购<label>免服务费还差{this.state.insPermission.balance}元</label></div>*/}
                        {/*    }*/}
                        {/*    <div className="con" style={{marginTop: '10px'}}>*/}
                        {/*        <div>*/}
                        {/*            <img style={{width: '40px', marginBottom: '4px'}} src={require("../assets/softPay/pic2.png")}/>*/}
                        {/*            <div>系统免费</div>*/}
                        {/*        </div>*/}
                        {/*        <div>*/}
                        {/*            <img style={{width: '40px', marginBottom: '4px'}} src={require("../assets/softPay/pic3.png")}/>*/}
                        {/*            <div>技术服务</div>*/}
                        {/*        </div>*/}
                        {/*        <div>*/}
                        {/*            <img style={{width: '40px', marginBottom: '4px'}} src={require("../assets/softPay/pic4.png")}/>*/}
                        {/*            <div>营销培训</div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*    <div className="payAct">立即充值</div>*/}
                        {/*</div>*/}
                    </Sider>
                    <Layout
                        style={{
                            // padding: '0 24px 24px',
                        }}
                    >
                        <Auth/>
                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            <ContentRouter/>
                        </ErrorBoundary>
                    </Layout>
                    <Modal
                        className="modalPermission"
                        width={1040}
                        footer={null}
                        closable={false}
                        open={this.state.showModal}  onCancel={() => {
                        this.setState({
                            showModal: false
                        })
                    }}>
                        <div>
                            <div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
                                <img src={require('../assets/userPic.png')} style={{width:'34px',borderRadius:'50%',marginRight:'5px', verticalAlign:'center'}}/>
                                <div>
                                    <div>{this.state.currentUserInfo.name}</div>
                                    <div style={{color: 'orangered', fontSize: '12px'}}>系统到期时间：{this.state.insPermission.endDate}</div>
                                </div>
                            </div>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <div style={{width: '240px', marginRight: '14px', height: '520px', padding: '20px 10px'}} className="permissionCon">
                                    <div className="conTitRemark">会员权益</div>
                                    {this.state.listP.map(item => {
                                        return (
                                            <div className="conRemark" style={{marginLeft: '10px'}}><CheckCircleOutlined style={{marginRight: '10px'}}/>{item.remark}</div>
                                        )
                                    })}
                                </div>
                                <div style={{flex: 1, height: '520px'}}>
                                    <div style={{marginBottom: '10px', height: '360px', flex: 1, padding: '14px 20px'}} className="permissionCon">
                                        {this.state.insPermission.plan === 'plan_a' && <div>
                                            <div className="perPmsCon" style={{border: '3px solid rgb(53,247,247)', height: '330px',}}>
                                                <div style={{display:'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                                                    <div style={{fontSize: '24px', fontWeight: 'bolder', marginBottom: '10px'}}>￥2800/年</div>
                                                    <div style={{fontSize: '16px', fontWeight: 'bolder', marginBottom: '6px', color: 'rgb(41, 83, 205)'}}>购买6000产品可抵</div>
                                                    <div className="subTit">距离产品采购<label>免服务费还差{this.state.insPermission.balance}元</label></div>
                                                </div>
                                                {this.state.list2.map(item => {
                                                    return ( <div>{item.remark}{item.msg && <label style={{fontSize: '12px'}}>{item.msg}</label>}</div>)
                                                })}
                                            </div>
                                        </div>}
                                        {this.state.insPermission.plan !== 'plan_a' && <div style={{display: 'flex'}}>
                                            <div className="perPmsCon" style={{border: '3px solid rgb(53,247,247)', width: '220px', position: 'relative', height: '330px', padding: '40px 10px 10px 10px', marginRight: '10px'}}>
                                                <div className="pmsBg1">方案一</div>
                                                <div style={{display:'flex', flexDirection: 'column', marginBottom: '20px'}}>
                                                    <div style={{fontSize: '24px', fontWeight: 'bolder',}}>￥6800/年</div>
                                                    <div style={{fontSize: '12px', color: 'rgb(244,137,40)'}}>购买1万产品可抵</div>
                                                </div>
                                                {this.state.list2.map(item => {
                                                    return ( <div>{item.remark}{item.msg && <label style={{fontSize: '12px'}}>{item.msg}</label>}</div>)
                                                })}
                                            </div>

                                            <div className="perPmsCon" style={{width: '220px', position: 'relative', height: '330px', padding: '40px 10px 10px 10px', marginRight: '10px'}}>
                                                <div className="pmsBg2">方案二</div>
                                                <div style={{display:'flex', flexDirection: 'column', marginBottom: '20px'}}>
                                                    <div style={{fontSize: '24px', fontWeight: 'bolder',}}>2年送1年</div>
                                                    <div style={{fontSize: '12px', color: 'rgb(244,137,40)'}}>¥13600/3年，购买2万产品可抵</div>
                                                </div>
                                                <div>除一年基础服务外</div>
                                                <div style={{color: 'rgb(41,83,205)', fontWeight: 500}}>赠新媒体服务</div>
                                                <div style={{display: 'flex'}}>
                                                    <div>含：</div>
                                                    <div style={{flex: 1}}>
                                                        <div>尾气治理专项账号搭建</div>
                                                        <div>拍摄、剪辑技巧培训</div>
                                                        <div>短视频文案样片支持</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="perPmsCon" style={{width: '240px', position: 'relative', height: '330px', padding: '40px 10px 10px 10px'}}>
                                                <div className="pmsBg2">方案三</div>
                                                <div style={{display:'flex', flexDirection: 'column', marginBottom: '20px'}}>
                                                    <div style={{fontSize: '24px', fontWeight: 'bolder',}}>3年享永久使用</div>
                                                    <div style={{fontSize: '12px', color: 'rgb(244,137,40)'}}>¥20400享永久使用权，购买3万产品可抵</div>
                                                </div>
                                                <div>除一年基础服务外</div>
                                                <div style={{color: 'rgb(41,83,205)', fontWeight: 500}}>赠新媒体服务</div>
                                                <div style={{display: 'flex'}}>
                                                    <div>含：</div>
                                                    <div style={{flex: 1}}>
                                                        <div>尾气治理专项账号搭建</div>
                                                        <div>拍摄、剪辑技巧培训</div>
                                                        <div>短视频文案样片支持</div>
                                                    </div>
                                                </div>
                                                <div style={{color: 'rgb(41,83,205)', fontWeight: 500}}>赠新媒体投流服务</div>
                                                <div>投流费门店承担，保障精准客资</div>
                                            </div>

                                        </div>}
                                    </div>
                                    <div style={{height: '150px', flex: 1, padding: '14px 20px',display: 'flex', alignItems: 'end', color: 'rgb(101,100,100)'}} className="permissionCon">
                                        <img style={{marginRight: '6px', width: '120px'}} src={require('../assets/softPay/pic5.png')}/>
                                        <img style={{width: '120px'}} src={require('../assets/softPay/pic6.png')}/>
                                        <div style={{marginLeft: '30px'}}>
                                            <div>应付金额：<span style={{fontSize: '30px', fontWeight: 'bolder', color: 'orangered'}}>{this.state.insPermission.plan !== 'plan_a' ? '￥6800' : '￥2800'}</span></div>
                                            <div>
                                                <img style={{width: '35px', marginRight: '4px'}} src={require('../assets/softPay/pic7.png')}/>
                                                <img style={{width: '35px', marginRight: '4px'}} src={require('../assets/softPay/pic8.png')}/>
                                                <label style={{fontSize: '12px'}}>使用微信/支付宝扫码支付</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </Layout>
            </Layout>
        )
    }
}
export default (withRouter(connect(null, mapDispatchToProps)(BasicLayout)))
